import { render, staticRenderFns } from "./schoolList.vue?vue&type=template&id=5b649246&scoped=true&"
import script from "./schoolList.js?vue&type=script&lang=js&"
export * from "./schoolList.js?vue&type=script&lang=js&"
import style0 from "./schoolList.vue?vue&type=style&index=0&id=5b649246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b649246",
  null
  
)

export default component.exports